<template>
  
  <div>
    <!-- im to lazy to type -->
    <div v-for="(value, property) in payload">
      <label>{{ property }}</label>
      <input v-model="payload[property]" />
    </div>
      
    <div>
      <button @click="save">Save</button>
    </div>
    
    <br />
    
    <hr />
  </div>
    
</template>

<script>
  export default {
    props: {
      payload: Object
    },
    
    methods: {
      
      validate() {
        return true
        //return false
      },
      
      save() {
        if (this.validate()) {
          this.$emit("save")       
        }
      }
      
    }
  };
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-core/address/Form.vue